import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Bishop from "./pages/Bishop";
import Clergy from "./pages/Clergy";
import ClergyProfile from "./pages/ClergyProfile";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import NotFound from "./pages/NotFound";
import EpiscopalOffice from "./pages/EpiscopalOffice";
import Parishes from "./pages/Parishes";
import Archdeaconries from "./pages/Archdeaconries";
import PastBishops from "./pages/PastBishops";
import RetiredPriests from "./pages/RetiredPriests";
import ParishProfile from "./pages/ParishProfile";
import ArchdeaconryProfile from "./pages/ArchdeaconryProfile";
import AlbumPage from "./pages/AlbumPage";
import EventDetails from "./pages/EventDetails";
import ScrollToTop from "./components/ScrollToTop";
import Videos from "./pages/Videos";
import Support from "./pages/Support";
import { HelmetProvider } from "react-helmet-async";


const helmetContext = {};

// Create QueryClient outside of component to maintain stable reference
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <HelmetProvider context={helmetContext} >
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <div className="min-h-screen bg-white">
            <Navigation />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/about/history" element={<About />} />
                <Route path="/about/vision-mission" element={<About />} />
                <Route path="/about/anthem" element={<About />} />
                <Route path="/bishop" element={<Bishop />} />
                <Route path="/episcopal-office" element={<EpiscopalOffice />} />
                <Route path="/clergy" element={<Clergy />} />
                <Route path="/clergy/:slug" element={<ClergyProfile />} />
                <Route path="/evangelist/:slug" element={<ClergyProfile />} />
                <Route path="/parishes" element={<Parishes />} />
                <Route path="/parishes/:slug" element={<ParishProfile />} />
                <Route path="/archdeaconries" element={<Archdeaconries />} />
                <Route path="/archdeaconries/:slug" element={<ArchdeaconryProfile />} />
                <Route path="/past-bishops" element={<PastBishops />} />
                <Route path="/retired-priests" element={<RetiredPriests />} />
                <Route path="/events" element={<Events />} />
                <Route path="/events/:slug" element={<EventDetails />} />
                <Route path="/videos" element={<Videos />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/gallery/:id" element={<AlbumPage />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/support" element={<Support />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </TooltipProvider>
    </HelmetProvider>
  </QueryClientProvider>
);

export default App;
